/**
 * @typedef {(ACTION_BOARD_DRAW_CARD_LEFT | ACTION_BOARD_DRAW_CARD_MIDDLE | ACTION_BOARD_DRAW_CARD_RIGHT | ACTION_BOARD_PLAY_CARD_LEFT | ACTION_BOARD_PLAY_CARD_MIDDLE | ACTION_BOARD_PLAY_CARD_RIGHT | STATE_BOARD_CARD_PLAYED | STATE_BOARD_HERO_MOVED | STATE_BOARD_ENDED | STATE_BOARD_READY)} TypeEvent An event.
 */

/**
 * The 'ACTION_BOARD_DRAW_CARD_LEFT' event.
 * @type {'ACTION_BOARD_DRAW_CARD_LEFT'}
 * @constant
 */
const ACTION_BOARD_DRAW_CARD_LEFT = 'ACTION_BOARD_DRAW_CARD_LEFT';

/**
 * The 'ACTION_BOARD_DRAW_CARD_MIDDLE' event.
 * @type {'ACTION_BOARD_DRAW_CARD_MIDDLE'}
 * @constant
 */
const ACTION_BOARD_DRAW_CARD_MIDDLE = 'ACTION_BOARD_DRAW_CARD_MIDDLE';

/**
 * The 'ACTION_BOARD_DRAW_CARD_RIGHT' event.
 * @type {'ACTION_BOARD_DRAW_CARD_RIGHT'}
 * @constant
 */
const ACTION_BOARD_DRAW_CARD_RIGHT = 'ACTION_BOARD_DRAW_CARD_RIGHT';

/**
 * The 'ACTION_BOARD_PLAY_CARD_LEFT' event.
 * @type {'ACTION_BOARD_PLAY_CARD_LEFT'}
 * @constant
 */
const ACTION_BOARD_PLAY_CARD_LEFT = 'ACTION_BOARD_PLAY_CARD_LEFT';

/**
 * The 'ACTION_BOARD_PLAY_CARD_MIDDLE' event.
 * @type {'ACTION_BOARD_PLAY_CARD_MIDDLE'}
 * @constant
 */
const ACTION_BOARD_PLAY_CARD_MIDDLE = 'ACTION_BOARD_PLAY_CARD_MIDDLE';

/**
 * The 'ACTION_BOARD_PLAY_CARD_RIGHT' event.
 * @type {'ACTION_BOARD_PLAY_CARD_RIGHT'}
 * @constant
 */
const ACTION_BOARD_PLAY_CARD_RIGHT = 'ACTION_BOARD_PLAY_CARD_RIGHT';

/**
 * The 'STATE_BOARD_CARD_PLAYED' event.
 * @type {'STATE_BOARD_CARD_PLAYED'}
 * @constant
 */
const STATE_BOARD_CARD_PLAYED = 'STATE_BOARD_CARD_PLAYED';

/**
 * The 'STATE_BOARD_HERO_MOVED' event.
 * @type {'STATE_BOARD_HERO_MOVED'}
 * @constant
 */
const STATE_BOARD_HERO_MOVED = 'STATE_BOARD_HERO_MOVED';

/**
 * The 'STATE_BOARD_ENDED' event.
 * @type {'STATE_BOARD_ENDED'}
 * @constant
 */
const STATE_BOARD_ENDED = 'STATE_BOARD_ENDED';

/**
 * The 'STATE_BOARD_READY' event.
 * @type {'STATE_BOARD_READY'}
 * @constant
 */
const STATE_BOARD_READY = 'STATE_BOARD_READY';

export {

    ACTION_BOARD_DRAW_CARD_LEFT,
    ACTION_BOARD_DRAW_CARD_MIDDLE,
    ACTION_BOARD_DRAW_CARD_RIGHT,
    ACTION_BOARD_PLAY_CARD_LEFT,
    ACTION_BOARD_PLAY_CARD_MIDDLE,
    ACTION_BOARD_PLAY_CARD_RIGHT,

    STATE_BOARD_CARD_PLAYED,
    STATE_BOARD_HERO_MOVED,
    STATE_BOARD_ENDED,
    STATE_BOARD_READY
};
